function showMessage(message, type) {
  const messageDiv = document.getElementById("subscription-message");
  if (messageDiv) {
    messageDiv.textContent = message;
    messageDiv.style.display = "block";
    messageDiv.style.color = type === "success" ? "#4CAF50" : "#f44336";

    if (type !== "success") {
      setTimeout(() => {
        messageDiv.style.display = "none";
      }, 5000);
    }
  }
}

async function subscribeToPostscript(phoneNumber, shopifyCustomerId) {
  try {
    const response = await fetch("https://api.postscript.io/api/v2/subscribers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer sk_ba40eef90b1f328732724ccb543a740e",
      },
      body: JSON.stringify({
        phone_number: phoneNumber,
        shopify_customer_id: shopifyCustomerId || null,
        shop_id: "672922",
        keyword: "MAILSMSSUBS",
        source: "footer-signup-form",
        origin: "website",
      }),
    });

    if (!response.ok) {
      const errorData = await response.text();
      console.error("Error subscribing:", errorData);
      showMessage("There was an error subscribing. Please try again later.", "error");
      return false;
    }

    console.log("Subscriber added successfully");
    showMessage("Thank you for subscribing!", "success");

    const form = document.querySelector("#footer-signup-form");
    if (form) {
      Array.from(form.children).forEach((child) => {
        if (!child.id || child.id !== "subscription-message") {
          child.remove();
        }
      });
    }

    return true;

  } catch (error) {
    console.error("Network error:", error);
    showMessage("Network error. Please check your connection and try again.", "error");
    return false;
  }
}

document.querySelector("#footer-signup-form").addEventListener("submit", async (e) => {
  e.preventDefault();
  const phone = e.target.querySelector('input[name="phone"]').value;
  const shopifyCustomerId = e.target.querySelector('input[name="shopify_customer_id"]')?.value || null;

  if (!phone) {
    showMessage("Phone number is required", "error");
    return;
  }

  await subscribeToPostscript(phone, shopifyCustomerId);
});

class NewsletterWrapper extends HTMLElement {
  constructor() {
    super();

    const form = this.querySelector("#email_newsletter-input-wrapper");
    const emailInput = this.querySelector("#email_newsletter");
    const messageDiv = this.querySelector("#subscription-message");

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      this.subscribeCustomer(emailInput.value, form, messageDiv);
    });
  }

  async subscribeCustomer(email, form, messageDiv) {
    try {
      const url = "https://a.klaviyo.com/client/subscriptions/?company_id=KWpXVB";

      const options = {
        method: "POST",
        headers: {
          accept: "application/json",
          revision: "2024-02-15",
          "content-type": "application/json",
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email.trim(),
                  },
                },
              },
            },
            relationships: {
              list: { data: { type: "list", id: "M8bbMe" } },
            },
          },
        }),
      };

       const response = await fetch(url, options);

      if (response.ok) {
        this.showMessage("Subscription successful", "success", form, messageDiv);
      } else {
        this.showMessage("Subscription failed. Please try again.", "error", form, messageDiv);
      }
    } catch (err) {
      console.error("Subscription error:", err);
      this.showMessage("Connection error. Please try again later.", "error", form, messageDiv);
    }
  }

  showMessage(message, type, form, messageDiv) {
    [...form.elements].forEach((el) => (el.style.display = "none"));

    messageDiv.textContent = message;
    messageDiv.style.display = "block";
    messageDiv.style.marginTop = "10px";
    messageDiv.style.fontWeight = "600";
    messageDiv.style.color = type === "success" ? "#4CAF50" : "#f44336";
  }
}

customElements.define("newsletter-wrapper", NewsletterWrapper);
